/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import styled from '@emotion/styled';
import React, { useState } from 'react';
import { Export } from '/views/export';
import { LAYOUT_OPTIONS } from '/views/explorer/layoutOptions';
import { LayoutSelector } from 'components/selectors/layoutSelector';
import { FlexSplitter, overflowEllipsis } from 'styles/styledComponentUtils';
import { SaveCurrentView, SaveExistingView } from '/views/save/saveCurrentView';
import { useIsSavedStateAvailable } from 'hooks/useApplicationState';
import { Button, ButtonGroup, Classes, Collapse, ControlGroup, Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { ViewSettingsDropDown } from './viewSettingsDropDown';
import { Sizes } from 'styles/variables-slykit';

/**
 * ViewSettings is responsible for providing a place to
 * save and load explorers and widgets.
 *
 * @param {boolean} showAllViews show views from all datasets?
 * @returns {*}
 * @constructor
 */
export const ViewSettings = ({ showAllViews = false }) => {
	const isSavable = useIsSavedStateAvailable();

	return (
		<div css={containerStyles}>

			<div css={headerStyles} >
				<strong>View Settings:</strong>
				<LayoutSelector
					layoutOptions={LAYOUT_OPTIONS}
					minimal
				/>
				<FlexSplitter />
				<Export />
			</div>

			{isSavable && (
				<ControlGroup fill css={actionButtonsStyles}>
					<ViewSettingsDropDown showAllViews={showAllViews} />
					<SaveExistingView />
					<SaveCurrentView />
				</ControlGroup>
			)}

		</div>
	);
};

const containerStyles = css`
	padding: ${Sizes.sm} ${Sizes.lg};

	.${Classes.BUTTON_TEXT}{
		${overflowEllipsis}
	}

	.${Classes.POPOVER_TARGET} > div {
		border-radius: inherit; // bp oversight?
	}
`;

const headerStyles = css`
	display: flex;
	align-items: center;
`

const actionButtonsStyles = css`
	margin: ${Sizes.sm} 0;
`;

